import React, { useMemo } from "react"
import { shuffle } from "assets/helper/shuffle"
import { StaticReviewOutput } from "contexts/settings/Integrations/integrationsSettings-types"
import { useIntegrationsSettings } from "hooks/useIntegrationsSettings"
import { TestimonialBanner } from "components/testimonial/TestimonialBanner"

export interface StaticReviewProps {
  staticReviews: StaticReviewOutput[]
  isLandingPage: boolean
}

export const StaticReview = ({
  staticReviews,
  isLandingPage,
}: StaticReviewProps) => {
  const { googleReviewsUrl } = useIntegrationsSettings()

  const getRating: { [key: string]: string } = {
    "n1 Star": "★",
    "n2 Stars": "★★",
    "n3 Stars": "★★★",
    "n4 Stars": "★★★★",
    "n5 Stars": "★★★★★",
  }

  const randomReview = useMemo(() => {
    const review = shuffle(staticReviews)
    return review
  }, [staticReviews])

  const {
    rating,
    review,
    reviewer,
    location,
    heading,
    reviewBackgroundImage,
    reviewImage,
  } = randomReview

  const stars = getRating[rating] || ""

  return (
    <TestimonialBanner
      googleReviewUrl={googleReviewsUrl}
      rating={stars}
      reviewerLocation={location}
      review={review}
      reviewerName={reviewer}
      avatar={reviewImage}
      backgroundImage={reviewBackgroundImage}
      heading={heading}
      isLandingPage={isLandingPage}
    />
  )
}
